import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { CHURCH } from "@/lib/content";
import { publicApi } from "@/lib/api";

const ContentContext = createContext({ ...CHURCH, reload: () => {} });

const merge = (data) => {
  const out = { ...CHURCH };
  Object.entries(data || {}).forEach(([k, v]) => {
    const filled = Array.isArray(v) ? v.length : v && typeof v === "object" ? Object.values(v).some(Boolean) : v;
    if (filled) out[k] = v;
  });
  return out;
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(CHURCH);
  const reload = useCallback(() => {
    Promise.all([publicApi.get("/public/content"), publicApi.get("/public/worship-schedules")])
      .then(([c, s]) => setContent({ ...merge(c.data), schedules: s.data })).catch(() => {});
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return <ContentContext.Provider value={{ ...content, reload }}>{children}</ContentContext.Provider>;
};

export const useContent = () => useContext(ContentContext);
